define.alias("ember-useragent/services/user-agent", "media/services/user-agent");